export const showDetailControl = (isReadyToRender, chartOption) =>
  Boolean(isReadyToRender && (chartOption?.[1] || chartOption?.[2]));
